import { Injectable } from '@angular/core';
import { BehavioralAssessment } from '../core-data-model/BehavioralAssessment.model';
import { Util } from '../core-utilities/Util';

@Injectable({ providedIn: 'root' })
export class BehavioralAssessmentFactory {
    constructor(private util: Util) {}

    new_BehavioralAssessment(obj?: Partial<BehavioralAssessment>) {
        return new BehavioralAssessment(this.util, obj);
    }
}
